import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { AiOutlineSetting } from "react-icons/ai";
import { firestore } from '../config/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const [tenantId, setTenantId] = useState(localStorage.getItem('tenantId')); 
  const location = useLocation();

  const getLinkClass = (path) => (location.pathname === path ? 'active' : '');
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedTenantId = localStorage.getItem('tenantId');
      if (updatedTenantId && updatedTenantId !== tenantId) {
        setTenantId(updatedTenantId);
        console.log("Tenant ID atualizado no localStorage:", updatedTenantId);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [tenantId]);

  useEffect(() => {
    const loadLogoUrl = async () => {
      

      if (!tenantId) {
        console.warn("tenantId não disponível.");
        return;
      }      

      try {
        const tenantDocRef = doc(firestore, 'inquilinos', tenantId);
        const tenantDocSnap = await getDoc(tenantDocRef);

        if (tenantDocSnap.exists()) {
          const data = tenantDocSnap.data();
          if (data.logoUrl) {
            
            const timestamp = new Date().getTime();
            const logoWithTimestamp = `${data.logoUrl}?t=${timestamp}`;
            setLogoUrl(logoWithTimestamp);
            
          } else {
            console.warn("Campo logoUrl não encontrado no documento.");
          }
        } else {
          console.warn("Documento do tenant não encontrado no Firestore.");
        }
      } catch (error) {
        console.error("Erro ao buscar o documento do tenant no Firestore:", error);
      }
    };

    loadLogoUrl();
  }, [tenantId]);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add('sticky');
        } else {
          navbar.classList.remove('sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!tenantId) {
    
    return <p>Carregando...</p>;
  }

  return (
    <div className="navbar">
      <button 
        className="menu-toggle" 
        onClick={toggleMenu}
        aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={isMenuOpen}
      >
        <span className="menu-icon">{isMenuOpen ? '✖' : '☰'}</span>
      </button>

      <div className="logo-container">
        {logoUrl ? (
          <img src={logoUrl} alt="Logo da Empresa" className="logo" onError={() => console.error("Erro ao carregar a imagem do logo:", logoUrl)} />
        ) : (
          <p>Carregando logo...</p>
        )}
      </div>

      <ul className={isMenuOpen ? 'active' : ''}>
        <li className={getLinkClass('/')}>
          <Link to="/" onClick={closeMenu}>Home</Link>
        </li>
        <li className={getLinkClass('/pilulas')}>
          <Link to="/pilulas" onClick={closeMenu}>Pílula</Link>
        </li>
        <li className={getLinkClass('/questoes')}>
          <Link to="/questoes" onClick={closeMenu}>Quiz</Link>
        </li>
        <li className={getLinkClass('/contatos')}>
          <Link to="/contatos" onClick={closeMenu}>Contatos</Link>
        </li>
        <li className={getLinkClass('/relatorios')}>
          <Link to="/relatorios" onClick={closeMenu}>Relatório</Link>
        </li>        
        <li className={getLinkClass('/configuracao')}>
          <Link to="/configuracao" onClick={closeMenu} aria-label="Configurações">
            <AiOutlineSetting size="35" className="settings-icon" />
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
